// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import PoolMachineMissingPkgCodeTable from './components/pool-machine-missing-std-pkg-code-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPoolMachineMissingStdkgCode } from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class PoolMachineMissingStdPkgCode extends Component {

    state = {
        results: []
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getPoolMachineMissingStdkgCode().then( response => {

            this.setState( {
                results: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    render () {

        const {
            results
        } = this.state;

        const poolMissingStdPkgCodeResult = results !== null && results.orderingCodes ?
            results.orderingCodes.map( i => ( { code: i, unitName: this.props.unit.name } ) ) : [];

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Pool Machine Missing Standard Package Code</h2>
                </header>

                <main>
                    <section className="section-container">
                        { results !== null && results.orderingCodes && (
                            <PoolMachineMissingPkgCodeTable
                                results={poolMissingStdPkgCodeResult}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

PoolMachineMissingStdPkgCode.displayName = 'PoolMachineMissingStdPkgCode';
PoolMachineMissingStdPkgCode.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( PoolMachineMissingStdPkgCode ) );
